import { AppState } from 'pages/app/state';
import { connect, Dispatch } from 'react-redux';
import { ManualInputModal } from './component';
import { Action } from 'helpers/action-helpers';
import { buildRawCode } from 'helpers/epc-helpers';
import { languageSelector } from 'pages/settings/selectors';
import { ManualEntryAction } from 'components/main/actions';

function mapStateToProps(state: AppState): object { 
  return { 
    language: languageSelector(state)
  }; 
}

// tslint:disable-next-line:no-any
function mapDisptachToProps(dispatch: Dispatch<Action>): object {
  return {
    submit: (productCode: string, serial: string, expiry: string, lotNumber: string) => {
      const epc = buildRawCode(productCode, serial, lotNumber, expiry);
      dispatch(new ManualEntryAction(epc));
    }
  };
}

export default connect(mapStateToProps, mapDisptachToProps)(ManualInputModal);


// WEBPACK FOOTER //
// ./src/components/manual-input-modal/container.ts